import { apiRequest } from '@/utils/request'

// 添加在线预约
export function addOnlineReserve(data) {
  return apiRequest({
    url: '/OnlineReserve/Add',
    method: 'post',
    data: data
  })
}

// 获取在线预约分页列表
export function getOnlineReservePagedList(queryParams) {
  return apiRequest({
    url: 'OnlineReserve/GetPagedList',
    method: 'get',
    params: queryParams
  })
}

// 获取在线预约列表
export function getOnlineReserveList(queryParams) {
  return apiRequest({
    url: 'OnlineReserve/GetList',
    method: 'get',
    params: queryParams
  })
}

// 在线预约查看详情
export function getOnlineReserveById(id) {
  return apiRequest({
    url: 'OnlineReserve/View?id=' + id,
    method: 'get'
  })
}
